import userReducer from '@app/store/slices/userSlice';
import authReducer from '@app/store/slices/authSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import customerReducer from '@app/store/slices/customerSlice';
import productReducer from '@app/store/slices/productSlice';
import supplierReducer from '@app/store/slices/supplierSlice';
import orderReducer from '@app/store/slices/orderSlice';
import storeReducer from '@app/store/slices/storeSlice';
import locationReducer from '@app/store/slices/locationSlice';
import productGroupReducer from '@app/store/slices/productGroupSlice';
import customerGroupReducer from '@app/store/slices/customerGroupSlice';
import bankReducer from '@app/store/slices/bankSlice';
import inventoryMovementReducer from '@app/store/slices/movementSlice';
import ledgerReducer from '@app/store/slices/ledgerSlice';
import employeeReducer from '@app/store/slices/employeeSlice';
import activityReducer from '@app/store/slices/activitySlice';
import bonusReducer from '@app/store/slices/bonusSlice';
import roleReducer from '@app/store/slices/roleSlice';
import permissionReducer from '@app/store/slices/permissionSlice';
import salaryReducer from '@app/store/slices/employee/salarySlice';
import inboxReducer from '@app/store/slices/inboxSlice';

export default {
  user: userReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
  customer: customerReducer,
  customer_group: customerGroupReducer,
  product: productReducer,
  product_group: productGroupReducer,
  supplier: supplierReducer,
  order: orderReducer,
  store: storeReducer,
  location: locationReducer,
  bank: bankReducer,
  movement: inventoryMovementReducer,
  ledger: ledgerReducer,
  employee: employeeReducer,
  activity: activityReducer,
  bonus: bonusReducer,
  role: roleReducer,
  permission: permissionReducer,
  salary: salaryReducer,
  inbox: inboxReducer,
};
